import DOMPurify from "dompurify";
import {useState} from "react";
import {IconType} from "react-icons";

import Button from "@/components/button/Button.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
// @ts-expect-error legacy
import TransactionUtils from "@/legacy/transaction/TransactionUtils.jsx";

interface StepDetailsModalProps {
  stepDetails?: string;
  icon: IconType;
  text: string;
}

export const StepDetailsModalButton = ({stepDetails, icon, text}: StepDetailsModalProps) => {
  const [showModal, setShowModal] = useState(false);
  if (!stepDetails) {
    return null;
  }
  const innerHTML = TransactionUtils.formatStepDetails(stepDetails);
  return (
    <div className="browser-console-output btn-group dropup">
      <ActionDialog
        onConfirm={() => setShowModal(false)}
        size="xl"
        title="Request Details"
        show={showModal}
        confirmBtnText="OK"
        onCancel={() => setShowModal(false)}
        hasCancelButton={false}
      >
        <div className="text-break" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(innerHTML)}} />
      </ActionDialog>
      <Button
        variant="ghost"
        size="fitContent"
        onClick={() => {
          setShowModal(true);
        }}
      >
        <TooltipIconRA
          placement="bottom"
          className="cursor-pointer"
          title={text}
          icon={icon}
          iconProps={{size: "kpi"}}
        />
      </Button>
    </div>
  );
};
